<template>
    <div v-resize="onResize" :style="'background-color:' + pageColor + '; height:' + contentHeight"
         class="registration-container">
      <div :style="'background-color:' + headerColor" class="header" ref="headerFooterContainerHeader">
        <!-- @slot the content of the fixed header section -->
        <slot name="header"/>
      </div>

      <v-container :fill-height="verticalCentered" :style="contentStyle" class="content mx-0 px-0" fluid>
        <v-container :class="`py-0 ${contentClass}`" :style="{maxWidth: contentMaxWidth}" fluid>
          <!-- @slot the content of the default section, exports footerHeight + headerHeight -->
          <slot :footerHeight="footerHeight" :headerHeight="headerHeight"/>
        </v-container>
      </v-container>

      <div v-if="hasFooterSlot"
           ref="headerFooterContainerFooter"
           :style="{backgroundColor: footerColor}"
           class="footer">
        <!-- @slot the content of the fixed footer section -->
        <slot name="footer"/>
      </div>
    </div>
</template>

<script>
export default {
    name: 'FinHeaderFooterContainer',
    props: {
        /** the color of the complete page */
        pageColor: {
            type: String,
            default: '#fff'
        },
        /** the color of the header slot section */
        headerColor: {
            type: String,
            default: 'transparent'
        },
        /** the color of the content (default) slot section */
        contentColor: {
            type: String,
            default: 'transparent'
        },
        /** the color of the footer slot section */
        footerColor: {
            type: String,
            default: 'transparent'
        },
        /** sets if the content section should be vertically centered */
        verticalCentered: {
            type: Boolean,
            default: false
        },
        /** align the content at the bottom next to the footer */
        bottomAlignedContent: {
            type: Boolean,
            default: false
        },
        /** sets the max width of the content section */
        contentMaxWidth: {
            type: String,
            default: '100%'
        },
        contentClass: {
            type: String,
            default: ''
        },
        contentHeight: {
            type: String,
            default: '100%'
        }
    },
    data() {
        return {
            headerHeight: 0,
            footerHeight: 0
        }
    },
    methods: {
        onResize() {
            this.$nextTick(() => {
                const {headerFooterContainerHeader, headerFooterContainerFooter} = this.$refs
                this.headerHeight = headerFooterContainerHeader?.clientHeight || 0
                this.footerHeight = headerFooterContainerFooter?.clientHeight || 0
            })
        }
    },
    computed: {
      hasFooterSlot() {
        return !!this.$slots.footer
      },
      contentStyle() {
        return {
          paddingTop: this.bottomAlignedContent ? 'auto' : this.headerHeight + 'px',
          paddingBottom: this.bottomAlignedContent ? 'auto' : this.footerHeight + 'px',
          marginTop: this.bottomAlignedContent ? this.headerHeight + 'px' : 'auto',
          marginBottom: this.bottomAlignedContent ? this.footerHeight + 'px' : 'auto',
          backgroundColor: this.contentColor,
          position: this.bottomAlignedContent ? 'fixed' : 'relative',
          bottom: this.bottomAlignedContent ? 0 : 'unset',
          zIndex: this.bottomAlignedContent ? 25 : 2,
          //overflowY: 'auto',
        }
      }
    },
    mounted() {
        this.onResize()
    }
}
</script>

<style scoped>
.registration-container {
    width: 100%;
    height: 100%;
}

.registration-container .header {
    position: fixed;
    top: 0;
    z-index: 3;
    left: 0;
    right: 0;
}

.registration-container .footer {
    position: fixed;
    bottom: 0;
    z-index: 20;
    left: 0;
    right: 0;
}
</style>
